import type { ReactNode } from 'react';
import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@/design-system/ui/toast';
import { AuthBootstrap } from '@/features/auth/components/AuthBootstrap';
import { LoginSheet } from '@/features/auth/components/LoginSheet';
import { queryClient } from './providers/query-client';
import { router } from './routes/router';

interface AppProps {
  children?: ReactNode;
  queryClient?: QueryClient;
}

export function App({ children, queryClient: customQueryClient }: AppProps = {}) {
  const qc = customQueryClient ?? queryClient;
  return (
    <QueryClientProvider client={qc}>
      <AuthBootstrap />
      {children ?? <RouterProvider router={router} />}
      <LoginSheet />
      <Toaster />
    </QueryClientProvider>
  );
}
